import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { LoaderState } from './loader';

@Injectable()

export class LoaderService {

    private loaderSubject = new Subject<LoaderState>();

    loaderState = this.loaderSubject.asObservable();
    constructor() { }

    public show() {
        this.loaderSubject.next(<LoaderState>{show: true});
    }

    public hide() {
        this.loaderSubject.next(<LoaderState>{show: false});
    }
}


// WEBPACK FOOTER //
// ./src/app/common/loadingBar/loader.service.ts